export default "__VITE_ASSET__BP_rk28Q__"